export const SPAN_FOR_HTTP = 'HTTP';
export const SPAN_KIND_CLIENT = 3;
export const SPAN_ATTR_HTTP_URL = 'url';
export const SPAN_ATTR_HTTP_METHOD = 'method';
export const SPAN_ATTR_HTTP_HEADERS = 'headers';
export const SPAN_ATTR_HTTP_PARAMS = 'params';
export const SPAN_ATTR_HTTP_DATA = 'data';
export const SPAN_ATTR_HTTP_BATCH = 'batch';
export const SPAN_ATTR_HTTP_CACHEABLE = 'cacheable';

export const SPAN_TRACE_PARENT = 'traceparent';
export const SPAN_DOCUMENT_TRACE_PARENT = 'X-DocumentTraceParent';
export const SPAN_ATTR_KIND = 'kind';
export const SPAN_ATTR_LEVEL = 'level';
export const SPAN_LEVEL_FINE = 100;
